import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import VueRouter from 'vue-router'
import { ApplicationGetters, IVacancy, LocalizationData, LocalizationPath, VacancyGetters } from '../../../../../../core/src'
import { getApplicationStore, VacancyCardText } from '../../../../../core/src'
import { LocalizationService } from '../../../../../core/src/modules/language/localization-service'
import { getLocalization } from '../../helper'
import { RouterLinkFactory } from '../../router-links/router-link.factory'
import { ButtonFactory } from '../c-button/button.factory'
import { LabelFactory } from '../c-label/factory/label.factory'
import CLabel from '../c-label/c-label.component.vue'
import CButton from '../c-button/c-button.component.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'c-vacancy-card-medium.component',
  props: {
  vacancy: {
    type: Object as PropType<IVacancy>,
    required: true
  },
  router: {
    type: Object as PropType<VueRouter>,
    required: true
  },
  App: {
    type: Object as PropType<any>,
    required: true
  }
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props;





const App = props.App
const localization: LocalizationData = getLocalization(App)
const wage = VacancyCardText.getFormattedPrioritizedWage(localization, props.vacancy)
const bonusText = !!props.vacancy.otherSalariesAndBonuses
  ? LocalizationService.t<string>(localization, LocalizationPath.performanceBonus)
  : ''
const location = [VacancyGetters.getLocation(props.vacancy)]
const category = VacancyGetters.getCategoryString(props.vacancy)
const jpLevel = VacancyGetters.getJapaneseConversationName(props.vacancy)
const wageLabel = LabelFactory.wages(wage, bonusText, 'text-small theme-shades-light1-white')
const locationLabel = LabelFactory.locations(location, 'text-small theme-shades-light1-white')
const categoryLabel = LabelFactory.category(category, 'text-small theme-shades-light1-white')
const jpLabel = LabelFactory.jpLevelSmall(jpLevel, 'text-small theme-shades-light1-white')
const viewJobLink = VacancyGetters.getVacancyLink(props.vacancy)
const language = App.localizationSelector.language
const localizedLink = RouterLinkFactory.localizedLink(viewJobLink!, language)
const viewJobButton = ButtonFactory.vacancyLinkButton(localization, { link: { router: props.router, link: localizedLink } })
const appliedButtonProps = ButtonFactory.vacancyLinkButtonDisabled(localization, {
  link: { router: props.router, link: localizedLink }
})
const getThumbnailUrl = VacancyGetters.getThumbnailUrl
const getTitle = VacancyGetters.getTitle
const getSummary = VacancyGetters.getSummary

const applicationStore = getApplicationStore()
const hasApplied = ApplicationGetters.hasApplied(props.vacancy.id!, applicationStore.values())
const disabledOverlayClass = hasApplied ? 'disabled-overlay-div' : ''

function goTo(e: Event): void {
  emit('click', props.vacancy)
  e.preventDefault()
  props.router.push(localizedLink)
}

return { __sfc: true,props, emit, App, localization, wage, bonusText, location, category, jpLevel, wageLabel, locationLabel, categoryLabel, jpLabel, viewJobLink, language, localizedLink, viewJobButton, appliedButtonProps, getThumbnailUrl, getTitle, getSummary, applicationStore, hasApplied, disabledOverlayClass, goTo, CLabel, CButton }
}

})